export default (initialState = {}) => {
  return () => {
    return {
      addl_bills: [],
      bill_id: null,
      billing_address: "",
      date: null,
      deal_setting: {},
      dispatch_address: "",
      freight: 0,
      have_addl_bills: false,
      lineitems: [],
      payment_terms: "",
      po_id: null,
      tcs: {},
      po_info: {},
      remarks: "",
      shipping_address: "",
      total_amount: null,
      total_tax: null,
      vehicle_number: "",
      ...initialState,
    };
  };
};
